<template>
  <div class="msg-bell-msg-view">
    <div class="main-content">
      <div class="app-main-inner-row" style="padding-top: 10px;">
        <div class="triggers">
          <span>{{ $t('CargoMsg.Cargo_TaskName') }}</span>
          <el-input
            v-model="pageInfo.jobNo"
            :placeholder="$t('SeaExport.PleaseInputAKeyword')"
            style="width:200px;margin: 0 10px"
            @input="searchHandle()"
          />
          <el-button type="primary" @click="searchHandle">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <el-button type="primary" @click="btnAdd">{{ $t('common.btn.new') }}</el-button>
          <el-button type="primary" @click="btnCopy">{{ $t('CargoMsg.Cargo_Copy') }}</el-button>
          <el-button type="primary" @click="btnEdit">{{ $t('CargoMsg.Cargo_EditTo') }}</el-button>
          <el-button type="danger" @click="btnRemoveHandler">{{ $t('common.btn.delete') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper" style="flex-grow: 1;">
        <cargo-ag-grid
          config-module="250821"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-options="gridOptions"
          :side-bar="sideBarDefs"
          style="width: 100%;"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="250822"
          :total="pageInfo.total"
          :page.sync="pageInfo.pageNum"
          :limit.sync="pageInfo.pageSize"
          @pagination="searchHandle"
        />
      </div>
    </div>

    <!--    新增 编辑-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="addDialog.visible"
      :close-on-click-modal="false"
      :title="addDialog.title"
      width="450px"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px">
        <div class="filters">
          <el-form label-width="85px" label-position="right">
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('CargoMsg.Cargo_TaskName')">
                <el-input v-model="addDialog.form.taskName" no="taskName" style="width: 300px" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_TaskScenario')">
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_User"
                  filterable
                  :default-value="addDialog.form.automationConfigUuid||''"
                  tag-value="uuid"
                  tag-name="taskName"
                  style="width: 300px;"
                  :static-options="automationConfigList"
                  :filter-tag-names="['taskName']"
                  :placeholder="$t('CargoMsg.Cargo_Select') + $t('CargoMsg.Cargo_TaskScenario')"
                  @parentCallBack="p=>{addDialog.form.automationConfigUuid=p.value;}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_ExecutionFrequency')">
                <el-radio-group v-model="addDialog.form.type" @change="onTypeChanged">
                  <el-radio label="hour">{{ $t('CargoMsg.Cargo_PerHour') }}</el-radio>
                  <el-radio label="day">{{ $t('CargoMsg.Cargo_Daily') }}</el-radio>
                  <el-radio label="week">{{ $t('CargoMsg.Cargo_Weekly') }}</el-radio>
                  <el-radio label="mon">{{ $t('CargoMsg.Cargo_Monthly2') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_StartExecutionTime')">
                <el-time-select
                  v-model="addDialog.form.startHour"
                  :picker-options="{
                    start: '00:00',
                    step: '00:30',
                    end: '23:30'
                  }"
                  format="HH"
                  placeholder="请选择小时"
                  style="width: 145px"
                />
              </el-form-item>
              <el-form-item
                v-if="addDialog.form.type === SystemConstants.TIME_TYPE_1.code"
                :label="$t('CargoMsg.Cargo_Every')"
              >
                <el-input v-model="addDialog.form.hour" no="taskName" style="width: 145px" />
                {{ $t('CargoMsg.Cargo_Hour') }}
              </el-form-item>
              <el-form-item v-if="addDialog.form.type === 'week'" :label="$t('CargoMsg.Cargo_SpecifiedWeekday')">
                <cargo-advance-select
                  :multiple="true"
                  filterable
                  :default-multiple-value="addDialog.form.weekList || []"
                  tag-value="code"
                  tag-name="chineseName"
                  :filter-tag-names="['chineseName']"
                  :cache="false"
                  :static-options="weekList"
                  :placeholder="' '"
                  style="width: 300px;"
                  @parentCallBack="p=>{addDialog.form.weekList=p.value;}"
                />
              </el-form-item>
              <el-form-item v-if="addDialog.form.type === 'mon'" :label="$t('CargoMsg.Cargo_SpecifiedDay')">
                <cargo-advance-select
                  :multiple="true"
                  filterable
                  :disabled="addDialog.form.lastDay"
                  :default-multiple-value="addDialog.form.dayList || []"
                  tag-value="code"
                  tag-name="code"
                  :filter-tag-names="['code']"
                  :cache="false"
                  :static-options="dayList"
                  :placeholder="' '"
                  style="width: 300px;"
                  @parentCallBack="p=>{addDialog.form.dayList=p.value;}"
                />
              </el-form-item>
              <el-form-item v-if="addDialog.form.type === 'mon'" label="">
                <el-checkbox v-model="addDialog.form.lastDay" label="L" @change="lastDayHandler">{{
                  $t('CargoMsg.Cargo_LastDayOfMonth')
                }}
                </el-checkbox>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_EffectiveTime')">
                <el-date-picker
                  v-model="addDialog.form.effectiveDateStart"
                  no="effectiveDateStart"
                  type="date"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 145px"
                />
                -
                <el-date-picker
                  v-model="addDialog.form.effectiveDateEnd"
                  no="effectiveDateEnd"
                  type="date"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 145px"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_TaskResult')">
                <el-checkbox v-model="addDialog.form.taskResult" no="taskResult" @change="taskResultHandler">{{
                  $t('CargoMsg.Cargo_TaskResultReminder')
                }}
                </el-checkbox>
              </el-form-item>
              <el-form-item :label="''">
                <cargo-advance-select
                  no="commissionPersonnel"
                  :multiple="true"
                  filterable
                  :disabled="!addDialog.form.taskResult"
                  :default-multiple-value="addDialog.form.taskResultUserList || []"
                  tag-value="userId"
                  tag-name="chineseName"
                  :filter-tag-names="['chineseName']"
                  :cache="false"
                  :static-options="userList"
                  :placeholder="$t('BusinessIntelligence.businessIntelligenceDashboard.selectPersonnel')"
                  style="width: 300px;"
                  @parentCallBack="p=>{addDialog.form.taskResultUserList=p.value;}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
                <el-input v-model="addDialog.form.remarks" no="remarks" type="textarea" :rows="3" style="width:300px" />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="onSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button @click="onCancel">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <task-log-dialog
      v-if="logDialog.visible"
      ref="taskLogDialog"
      :visible.sync="logDialog.visible"
      :form="logDialog.form"
      @close="logDialog.visible= false"
    />
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { DocumentManage } from '@/utils/commonUtil'
import {
  copyConfigFunc,
  deleteAutoConfigFunc,
  saveConfigFunc, checkTaskNameFunc,
  queryTaskFunc, executionTaskFunc
} from '@/api/sysAutoConfig/sysAutoTask'
import { queryFunc } from '@/api/sysAutoConfig/sysAutoConfig'
import TaskLogDialog from '@/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/component/taskLogDialog.vue'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { AutomationTask } from '@/class/model/sys/AutomationTask'
import $store from '@/store'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { generateScriptFunc } from '@/api/seaExport/intelligentBooking'

export default {
  name: 'AutomationTask',
  components: {
    cargoUserSelect,
    TaskLogDialog,
    cargoAdvanceSelect
  },
  data() {
    return {
      loading: null,
      selectedRow: null,
      documentManage: new DocumentManage(),
      SystemConstants,
      userList: [],
      automationConfigList: [],
      weekList: Array.from(SystemConstants.WEEKS), // 一周
      dayList: Array.from({ length: 31 }, (_, i) => ({ code: i + 1 })), // 31天
      addDialog: {
        visible: false,
        title: '',
        action: 'add',
        form: new AutomationTask().fillDefaultValue().getData()
      },
      logDialog: {
        visible: false,
        form: {}
      },
      autoConfigDialog: {
        visible: false
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TaskName'),
          field: 'taskName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_TaskScenario'),
          field: 'automationConfigUuid',
          width: 200,
          cellRenderer: params => {
            if (!this.automationConfigList || this.automationConfigList.length === 0) {
              return ''
            }
            const d = this.automationConfigList.find(p => p.uuid === params.value)
            return d ? d.taskName : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_TimingMethod'),
          field: 'hour',
          width: 200,
          cellRenderer: params => {
            if (!params.value) {
              return ''
            }
            return this.$t('CargoMsg.Cargo_Every') + params.value + this.$t('CargoMsg.Cargo_Hour')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UpdatePerson'),
          field: 'modifiedBy',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LastUpdateTime'),
          field: 'dateModified',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Status'),
          field: 'executionStatus',
          width: 200,
          cellStyle: (params) => {
            return { color: Number(params.data.executionStatus) === 0 ? 'red' : '' }
          },
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            if (Number(params.value) === 1) {
              return this.$t('CargoMsg.Cargo_Enabled')
            } else {
              return this.$t('CargoMsg.Cargo_Disabled')
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LastExecutionTime'),
          field: 'executionDate',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ExecutionLog'),
          field: 'executionStatus',
          noExport: true,
          width: 200,
          cellRenderer: params => {
            const onLog = this.documentManage.getPath('onLog')
            return `<div onclick="${onLog}('${params.data.automationConfigUuid}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_ExecutionLog')}</div>`
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: 'executionStatus',
          noExport: true,
          width: 200,
          cellRenderer: params => {
            const onExecutionTask = this.documentManage.getPath('onExecutionTask')
            if (params.value) {
              return `<div onclick="${onExecutionTask}('${params.data.uuid}', 0)" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_Disable')}</div>`
            }
            return `<div onclick="${onExecutionTask}('${params.data.uuid}', 1)" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_Enable')}</div>`
          }
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: event => {
          this.selectedRow = event.data
        }
      },
      filterJson: {},
      pageInfo: {
        jobNo: '',
        total: 0,
        pageNum: 1,
        pageSize: 20
      }
    }
  },
  computed: {
    TYPE_NAMES() {
      return TYPE_NAMES
    },
    language() {
      return this.$store.getters.language === 'zh'
    }
  },
  mounted() {

  },
  beforeMount() {
    const context = this
    this.documentManage.set('onExecutionTask', function(value, value1) {
      context.onExecutionTask(value, value1)
    })
    this.documentManage.set('onLog', function(value) {
      context.onLog(value)
    })
  },
  async created() {
    this.userList = getCacheListByKey(basicCacheKeys.basic_data_User)
    await this.init()
    await this.searchHandle()
  },
  methods: {
    async init() {
      this.automationConfigList = []
      queryFunc({ pageNum: 1, pageSize: 1000 }).then(res => {
        this.automationConfigList = res.data.list
      })
    },
    async searchHandle() {
      this.filterJson.jobNo = this.pageInfo.jobNo
      this.filterJson.pageNum = this.pageInfo.pageNum
      this.filterJson.pageSize = this.pageInfo.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      queryTaskFunc(this.filterJson).then(res => {
        this.pageInfo.total = Number(res.data.total)
        this.pageInfo.pageNum = res.data.pageNum
        this.pageInfo.pageSize = res.data.pageSize
        this.rowData = res.data.list
      })
    },
    // 新增
    btnAdd() {
      this.addDialog.form = new AutomationTask().fillDefaultValue().getData()
      this.addDialog.title = this.$t('CargoMsg.Cargo_New') + this.$t('CargoMsg.Cargo_AutomationTask')
      this.addDialog.action = 'add'
      this.addDialog.visible = true
      this.addDialog.form.type = SystemConstants.TIME_TYPE_1.code
    },
    btnEdit() {
      const items = this.gridOptions.api.getSelectedRows()
      if (!items || items.length !== 1) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneEntry'))
        return
      }
      this.addDialog.form = new AutomationTask().fillDefaultValue().getData()
      this.addDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_AutomationTask')
      this.addDialog.action = 'edit'
      this.addDialog.form = { ... items[0] }
      this.addDialog.visible = true
    },
    btnCopy() {
      const items = this.gridOptions.api.getSelectedRows()
      if (!items || items.length !== 1) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneEntry'))
        return
      }
      const loading = getLoading4Cxt(this)
      copyConfigFunc({ uuid: items[0].uuid }).then(res => {
        this.searchHandle()
      }).finally(res => {
        loading.close()
      })
    },
    btnRemoveHandler() {
      const items = this.gridOptions.api.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneEntry'))
        return
      }
      for (const data of items) {
        if (data.executionStatus === 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_EnabledStatusCannotDelete', [data.taskName]))
          return
        }
      }
      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmDeleteTaskScenario'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const keys = Array.from(items, p => p.uuid)
        const loading = getLoading4Cxt(this)
        deleteAutoConfigFunc({ keys: keys }).then(res => {
          this.searchHandle()
        }).finally(res => {
          loading.close()
        })
      })
    },
    async onExecutionTask(uuid, status) {
      await this.$confirm(status === 1 ? this.$t('SystemMaintenance.AreYouWantToEnable') : this.$t('SystemMaintenance.AreYouWantToDisable2'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('constant.yes'),
        cancelButtonText: this.$t('constant.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        const loading = getLoading4Cxt(this)
        executionTaskFunc({ keys: [uuid], anyInteger: status }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_RefreshCompleteStatus'))
          this.searchHandle()
        }).finally(res => {
          loading.close()
        })
      })
    },
    // 查看日志
    async onLog(uuid) {
      const data = this.rowData.filter(row => row.automationConfigUuid === uuid)
      if (data && data.length > 0) {
        this.logDialog.form.uuid = data[0].automationConfigUuid
        this.logDialog.visible = true
      }
    },
    onTypeChanged() {
    },
    lastDayHandler(e) {
      if (this.addDialog.form.lastDay) {
        this.addDialog.form.dayList = []
      }
    },
    taskResultHandler(e) {
      if (this.addDialog.form.taskResult) {
        this.addDialog.form.taskResultUserList = []
      }
    },
    getMessage() {
      const text = this.$t('CargoMsg.Cargo_StartExecutionTime') + this.$t('CargoMsg.Cargo_Daily') + this.addDialog.form.startHour
      if (this.addDialog.form.type === SystemConstants.TIME_TYPE_1.code) {
        return text + ',' + this.$t('CargoMsg.Cargo_Every') + this.addDialog.form.hour + this.$t('CargoMsg.Cargo_Hour')
      }
      if (this.addDialog.form.type === SystemConstants.TIME_TYPE_2.code) {
        return text
      }
      if (this.addDialog.form.type === SystemConstants.TIME_TYPE_3.code) {
        const tList = []
        for (const week of this.addDialog.form.weekList) {
          const w = this.weekList.find(p => p.code === week)
          if (w) {
            tList.push(w.chineseName)
          }
        }
        return text + ',' + this.$t('CargoMsg.Cargo_Weekly') + tList.join(',')
      }
      if (this.addDialog.form.type === SystemConstants.TIME_TYPE_4.code) {
        if (this.addDialog.form.lastDay) {
          return text + ',' + this.$t('CargoMsg.Cargo_LastDayOfMonth')
        } else {
          return text + ',' + this.$t('CargoMsg.Cargo_Monthly2') + this.addDialog.form.dayList.join(',') + this.$t('CargoMsg.Cargo_Days')
        }
      }
    },
    onSave() {
      if (!this.addDialog.form.taskName || !this.addDialog.form.taskName.trim()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TaskNameCannotBeEmpty'))
        return
      }
      if (!this.addDialog.form.automationConfigUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_TaskScenario'))
        return
      }
      if (!this.addDialog.form.effectiveDateStart || !this.addDialog.form.effectiveDateEnd) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_EffectiveTime'))
        return
      }
      if (this.addDialog.form.taskResult && (!this.addDialog.form.taskResultUserList || this.addDialog.form.taskResultUserList.length === 0)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_NotificationPersonnel'))
        return
      }

      const params = {
        anyStr: this.addDialog.form.taskName
      }
      if (this.addDialog.action === 'edit') {
        params.anyStr1 = this.addDialog.form.uuid
      }
      checkTaskNameFunc(params).then(res => {
        if (res.data) {
          this.$message.warning(this.$t('CargoMsg.Cargo_TaskNameAlreadyExists', [this.addDialog.form.taskName]))
        } else {
          this.nextHandler()
        }
      })
    },
    nextHandler() {
      this.loading = getLoading()
      const dataMessage = this.getMessage()
      if (this.addDialog.form.tipMessage !== dataMessage) {
        // 提示词发生改变 ai重新获取cron
        generateScriptFunc({ anyStr: dataMessage, anyStr1: 'queryCron' }).then(res => {
          this.addDialog.form.cron = res.data
          this.addDialog.form.tipMessage = dataMessage
          if (!res.data) {
            this.$message.success(this.$t('CargoMsg.Cargo_SaveFailed'))
            this.loading.close()
          }
          this.doSave()
        })
      } else {
        this.doSave()
      }
    },
    doSave() {
      this.addDialog.form.branchId = $store.getters.currentOfficeId
      saveConfigFunc(this.addDialog.form).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.addDialog.visible = false
        this.searchHandle()
        this.loading.close()
      })
    },
    // 取消
    onCancel() {
      this.addDialog.visible = false
    }
  }
}
</script>
